function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23 6L18 2V10L23 6Z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 2H17.5C17.5 1.8078 17.6102 1.63261 17.7834 1.54935C17.9566 1.46609 18.1623 1.4895 18.3123 1.60957L18 2ZM23 6L23.3123 5.60957C23.431 5.70445 23.5 5.84811 23.5 6C23.5 6.15189 23.431 6.29555 23.3123 6.39043L23 6ZM18 10L18.3123 10.3904C18.1623 10.5105 17.9566 10.5339 17.7834 10.4507C17.6102 10.3674 17.5 10.1922 17.5 10H18ZM18.3123 1.60957L23.3123 5.60957L22.6877 6.39043L17.6877 2.39043L18.3123 1.60957ZM23.3123 6.39043L18.3123 10.3904L17.6877 9.60957L22.6877 5.60957L23.3123 6.39043ZM17.5 10V2H18.5V10H17.5Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0323 20C16.5845 20 17.0323 20.4477 17.0323 21C17.0323 21.5523 16.5845 22 16.0323 22V20ZM18 7H9.5V5H18V7ZM9.5 20H16.0323V22H9.5V20ZM3 13.5C3 17.0899 5.91015 20 9.5 20V22C4.80558 22 1 18.1944 1 13.5H3ZM1 13.5C1 8.80558 4.80558 5 9.5 5V7C5.91015 7 3 9.91015 3 13.5H1Z"
});

function SvgRedo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-redo",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.b6e5f9f2.svg";
export { ForwardRef as ReactComponent };